var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66936",
    "data-name": "Group 66936",
    transform: "translate(-61 -85)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2391",
    "data-name": "Ellipse 2391",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(61 85)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paperclip",
    d: "M13.539,9.86,12.355,8.677,7.031,3.352A2.51,2.51,0,0,0,3.481,6.9l5.325,5.326a.558.558,0,0,0,.789-.789L4.27,6.113A1.394,1.394,0,0,1,6.242,4.141l5.326,5.325,1.183,1.183A2.511,2.511,0,1,1,9.2,14.2l-.986-.986L2.692,7.691,2.3,7.3A3.626,3.626,0,0,1,7.425,2.169l5.916,5.917A.558.558,0,1,0,14.13,7.3L8.214,1.38A4.741,4.741,0,0,0,1.509,8.085L7.425,14l.987.986A3.626,3.626,0,0,0,13.539,9.86Zm0,0",
    transform: "translate(69.661 93.001)",
    fill: "#5b5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.c4ef602a052bdbe2dc8da16a801c2047.svg";
export { ForwardRef as ReactComponent };